// Modules
import React from 'react'
import { withFormik } from 'formik'
import * as H from 'history'
import { ErrorResponse } from 'apollo-link-error'

// Application
import { Contact, ContactData, PhoneContact, PatientLogin, EmailContact, ContactTypes } from 'typings/signup'
import { OutputErrorCode, OutputErrorMsg, ROUTES_PATH } from 'constants/index'

// Components
import { InnerForm, FormValues } from '../InnerForm'

export interface WrapperProps {
    setContactEmail: (email: ContactData) => Promise<void>
    setContactPhone: (phone: ContactData) => Promise<void>
    setIsLoading: (loading: boolean) => void
    createLogin: (patient: PatientLogin) => Promise<void>
    federalTaxId: string | undefined
    biologicalSex: string | undefined
    openToast: (message: string) => void
    password: string | undefined
    contact: Contact
    phoneContacts: Array<PhoneContact>
    emailContacts: Array<EmailContact>
    history: H.History
}

export const Wrapper: React.ComponentType<WrapperProps> = withFormik<WrapperProps, FormValues>({
    mapPropsToValues: ({ contact, phoneContacts, emailContacts }) => {
        let current: PhoneContact | EmailContact | undefined
        let isPhone: boolean
        if (contact?.cellphone) {
            current = phoneContacts.find(item => item.value === contact?.cellphone?.value)
            isPhone = true
        } else if (contact?.email) {
            current = emailContacts.find(item => item.value === contact?.email?.value)
            isPhone = false
        } else {
            current = phoneContacts.length > 0 ? phoneContacts[0] : emailContacts[0]
            isPhone = phoneContacts.length > 0
        }
        const actual = {
            id: current?.id,
            value: current?.value,
        }
        return {
            contactId: actual.id?.toString(),
            contactValue: actual.value,
            contactType: isPhone ? ContactTypes.MOBILE : ContactTypes.EMAIL,
            phoneContacts,
            emailContacts,
        }
    },
    handleSubmit: async (values, formikBag) => {
        const { props } = formikBag

        try {
            props.setIsLoading(true)
            if (props.password && props.federalTaxId) {
                const contactData: ContactData = {
                    id: parseInt(values.contactId as string, 10),
                    value: values.contactValue,
                }
                const patient = {
                    password: props.password,
                    cpf: props.federalTaxId,
                    contactId: contactData.id,
                    biologicalSex: props.biologicalSex,
                }
                if (values.contactType === ContactTypes.EMAIL) {
                    await props.setContactEmail(contactData)
                } else {
                    await props.setContactPhone(contactData)
                }
                await props.createLogin(patient)
            }
            props.setIsLoading(false)
            props.history.push(ROUTES_PATH.SIGN_UP_VALIDATE_TOKEN)
        } catch (err) {
            const e: ErrorResponse = err
            if (e.graphQLErrors) {
                const error = e.graphQLErrors[0].extensions?.code
                if (error === OutputErrorCode.PHONEALREADYINUSE || error === OutputErrorCode.EMAILALREADYINUSE) {
                    props.openToast(OutputErrorMsg.PHONEALREADYINUSE)
                } else {
                    props.openToast(OutputErrorMsg.GENERICERROR)
                }
            }
            props.setIsLoading(false)
        }
    },
})(InnerForm)
